module.exports = __webpack_public_path__ + "img/atmel.cba7bc28.jpg";